// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isObject = (value: any) => {
    if (value === null) {
        return false;
    }

    return typeof value === "function" || typeof value === "object";
};
